<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
      <el-button type="warning" icon="el-icon-arrow-left" @click="toCamera"
        >返回</el-button
      >
        <el-form-item label="通道号" style="margin-left:30px">
          <el-input
            v-model.trim="formInline.channelNo"
            placeholder="请输入通道号"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="通道号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.channelNo }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备编号"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceSerial
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="通道名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.channelName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否加密"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.isEncrypt == 1?"加密":"不加密"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="IPC关联"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.relatedIpc?"是":"否"
                }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="封面图片"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <img style="width:24px;height:24px" :src="scope.row.picUrl" />
              </template>
            </el-table-column> -->
            <el-table-column
              label="设备状态"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px; color: #85ce61"
                  v-if="scope.row.status == 1"
                  >在线</span
                >
                <span style="margin-left: 10px; color: #f78989" v-else>
                  离线
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- icon="el-icon-edit" -->
                
                <el-button
                  type="success"
                  size="mini"
                  @click="handlePlay(scope.$index, scope.row)"
                  >播放</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 弹出新增,修改 -->
      <el-dialog
        :title="isAdd ? '新增' : '修改'"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="通道号"
            :label-width="formLabelWidth"
            prop="channelNo"
          >
            <el-input-number
              v-model.trim="form.channelNo"
              placeholder="请输入通道号"
              :min="1"
              :max="999"
              style="width: 240px"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="通道名称"
            :label-width="formLabelWidth"
            prop="channelName"
          >
            <el-input
              v-model.trim="form.channelName"
              placeholder="请输入通道名称"
              style="width: 240px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="通道位置"
            :label-width="formLabelWidth"
            prop="channelLocation"
          >
            <el-input
              v-model.trim="form.channelLocation"
              placeholder="请输入通道位置"
              style="width: 240px"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 弹出视频播放 -->
      <el-dialog
        title="视频播放"
        :visible.sync="playVisible"
        width="850px"
        style="margin-top: -11vh;"
        @close="handleClose"
        center
        class="playDialog"
      >
        <iframe
          :src="playUrl"
          width="800"
          height="600"
          id="ysOpenDevice"
          allowfullscreen
          v-if="playUrl"
        >
        </iframe>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closePlay">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      // 是否为新增
      isAdd: true,
      addLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceno: "",
      deviceSerial:"",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        channelNo: null,
      },
      // 表单dialog
      dialogFormVisible: false,
      form: {
        channelNo: "",
        channelName: "",
        channelLocation: "",
      },
      formLabelWidth: "120px",
      rules: {
        // 新增正则验证匹配规则
        channelNo: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          // { min: 1, max: 999, message: "通道号在 1 到 999 之间" }, //by  guo 2020-4-26-18:12修改
          // { min: 1, max: 10, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        channelName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        channelLocation: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],
      },

      //   视频播放弹窗
      playVisible: false,
      // 摄像头id
      deviceId: "",
      // 视频播放地址
      playUrl: "",
    };
  },
  methods: {
    //点击查询
    onSearch(newVal, oldVal) {
      console.log(newVal, oldVal);
      this.getTableData((this.pageNum = 1), (this.pageSize = 10));
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getTableData(
          this.formInline.channelNo,
          (this.pageNum = 1),
          (this.pageSize = 20)
        );
      }
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
    // 返回按钮
    toCamera() {
      bus.$emit('close_current_tags');
    },
    // 通道播放
    handlePlay(index, row) {
      // 获取播放地址
      let params = {
        deviceSerial: row.deviceSerial,
        code: "",
        channelNo:row.channelNo
      };
      this.$postJson("dmc/yingShiChannel/getPlayUrl", params).then((res) => {
        if (res.code == 200) {
          console.log(res.result, "play");
          let play = res.result;
          console.log(play.url);
          console.log(play.accessToken);
          let playUrl = `https://open.ys7.com/ezopen/h5/iframe?url=${play.url}&autoplay=1&audio=1&accessToken=${play.accessToken}`;
          this.playUrl = playUrl;
          this.playVisible = true;
          console.log(playUrl, "playUrl");
        }
      });
      console.log(row, "row");
    },
    // 关闭播放弹窗
    closePlay() {
      this.playVisible = false;
    },
    // 播放关闭回调
    handleClose() {
      this.playUrl = "";
    },
    // 新增按钮
    onAdd() {
      this.isAdd = true;
      this.dialogFormVisible = true;
    },
    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      this.isAdd = false;
      this.form = Object.assign({}, row);
      this.form.channelNo = String(this.form.channelNo);
      this.dialogFormVisible = true;
    },
    //关闭新增的dialog
    closexz() {
      this.form = {};
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
    },

    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            deviceId: this.deviceId,
            channelNo: this.form.channelNo,
            channelName: this.form.channelName,
            channelLocation: this.form.channelLocation,
          };
          let url = "dmc/yingShiChannel/save";
          if (!this.isAdd) {
            url = "dmc/yingShiChannel/edit";
            param.id = this.form.id;
          }
          console.log(param);
          this.addLoading = true;
          this.$postJson(url, param).then((res) => {
            console.log(res, "res");
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              this.getTableData();
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
            this.addLoading = false;
            this.dialogFormVisible = false;
          });
        }
      });
    },
    //删除
    handleDelete(index, row) {
      if (row.bindType == null) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            let id = row.id;
            console.log(id);
            this.$postJson("dmc/yingShiChannel/deleteById/" + id).then(
              (res) => {
                if (res.code == 200) {
                  this.getTableData();
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      }
    },

    //获取表格数据
    getTableData() {
      let channelNo = Number(this.formInline.channelNo);
      // 判断输入的通道号是不是数字类型
      if (!isNaN(channelNo)) {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          deviceId: this.deviceId,
          deviceSerial: this.deviceSerial,
          channelNo: this.formInline.channelNo,
        };
        console.log(param);
        this.loading = true;
        this.$postJson("dmc/yingShiChannel/queryListWithPage", param).then(
          (res) => {
            console.log(res);
            //判断是否有数据
            if (res.code == 200) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.list = res.result.list;
              setTimeout(() => {
                this.loading = false;
              }, 500);
            } else {
              this.list = [];
              this.totalDataNumber = 0;
              setTimeout(() => {
                this.loading = false;
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 3000);
            }
          }
        );
      } else {
        return this.$message({
          message: "请输入正确的通道号",
          type: "error",
        });
      }
    },
    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },
  mounted() {
    this.deviceId = this.$route.query.id;
    this.deviceSerial = this.$route.query.no;
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}
.playDialog ::deep .el-dialog__body{
  padding: 5px;
}
</style>
